/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
import React, { useState, useEffect } from 'react'
import { isMobile } from 'react-device-detect'
import { UnsupportedChainIdError, useWeb3React } from '@web3-react/core'
import { WalletConnectConnector } from '@web3-react/walletconnect-connector'
import { AbstractConnector } from '@web3-react/abstract-connector'
import usePrevious from '../../hooks/usePrevious'
import { useWalletModalToggle }  from '../../hooks/useApplication'
import { useDispatch , useSelector} from 'react-redux'
import { reactLocalStorage } from 'reactjs-localstorage'

import { SUPPORTED_WALLETS } from '../../constants'
import { setConnectError   } from '../../redux/slices/applicationSlice'
import  {setWithExpiry } from '../../utils/localstoageHelper'
import { clearSessionWalletConnect } from '../../utils'


import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from 'reactstrap'
import './style.scss'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faTimes,
  faCheckCircle,
  faArrowDown,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons'



const WALLET_VIEWS = {
  OPTIONS: 'options',
  OPTIONS_SECONDARY: 'options_secondary',
  ACCOUNT: 'account',
  PENDING: 'pending',
}

export default function WalletModal({
  // pendingTransactions,
  // confirmedTransactions,
  // ENSName,
}: {
  // pendingTransactions: string[] // hashes of pending
  // confirmedTransactions: string[] // hashes of confirmed
  // ENSName?: string
}) {
  // important that these are destructed from the account-specific web3-react context
  const { active, account, connector, activate, error } = useWeb3React()

  const [walletView, setWalletView] = useState(WALLET_VIEWS.ACCOUNT)

  const [pendingWallet, setPendingWallet] = useState<AbstractConnector | undefined>()

  const [pendingError, setPendingError] = useState<boolean>()

  const [errorMsg , setErrorMsg] = useState<string>('')

  const appState = useSelector(state => state.application)
  const dispatch = useDispatch()
  const {  isShowModalWallet ,isConnectError ,connectErrorMessage }  = appState
  const   toggleWalletModal =   useWalletModalToggle()


  const previousAccount = usePrevious(account)

  // close on connection, when logged out before
  useEffect(() => {
    if (account && !previousAccount && isShowModalWallet) {
      toggleWalletModal()
    }
  }, [account, previousAccount, toggleWalletModal, isShowModalWallet])

 // close modal when a connection is successful
 const activePrevious = usePrevious(active)
 const connectorPrevious = usePrevious(connector)
 useEffect(() => {
   if (isShowModalWallet && ((active && !activePrevious) || (connector && connector !== connectorPrevious && !error))) {
    setWalletView(WALLET_VIEWS.ACCOUNT)
   }
 }, [setWalletView, active, error, connector, isShowModalWallet, activePrevious, connectorPrevious])


  const tryActivation = async (connector: AbstractConnector | undefined , providerName:string | '') => {
     
     
    setPendingWallet(connector) // set wallet for pending view
    setWalletView(WALLET_VIEWS.PENDING)

    dispatch(setConnectError(
      {
        isConnectError : false,
        connectErrorMessage :''
      }
    ))

    

    // if the connector is walletconnect and the user has already tried to connect, manually reset the connector
    if (connector instanceof WalletConnectConnector && connector.walletConnectProvider?.wc?.uri) {
      connector.walletConnectProvider = undefined
    }
 

    if (connector) {

      if( providerName == "MetaMask" && isMobile  && connector?.walletConnectProvider == undefined){
          //TODO : unspport 
          dispatch(setConnectError(
            {
              isConnectError : true,
              connectErrorMessage :'Unsupported wallet provider \n Please change your wallet.'
            }
          ))
      }
    

        try {
          await  activate(connector, undefined, true)
          reactLocalStorage.set('isLogin', true)
          if(isMobile &&  providerName == "WalletConnect" ) {
              setWithExpiry("isloginWalletConnect" , true)
          }

        }catch(err){
          //console.log(error)
          if (err instanceof UnsupportedChainIdError) {
          
            //TODO 
            dispatch(setConnectError(
              {
                isConnectError : true,
                connectErrorMessage :'Unsupported Chain Id \n Please check your chain Id.'
              }
            ))
            try {
              clearSessionWalletConnect()
            }catch(ex){

            }
              
         
           // activate(connector) // a little janky...can't use setError because the connector isn't set
          } else {
            console.log(error)
            setPendingError(true)
          }
        }
    }
  }

  function getOptions() {
    const isMetamask = window.ethereum && window.ethereum.isMetaMask
    return Object.keys(SUPPORTED_WALLETS).map((key, i) => {
      const option = SUPPORTED_WALLETS[key]
      return (
         <button key={`btn_${i}`} className="btn  option-btn"  onClick={ () => tryActivation(option.connector , option.name)}>
           <div key={option.name + i}  className="wallet-info">
                  <label>{option.name}</label>
                  <div className="wallet-icon-warp">
                      <img src={ require(`../../assets/images/${option.iconName}`)?.default} ></img>
                  </div>
     
           </div>
          
           
           </button>
         )
       
    })

  }

  return (
    <div>
    <Modal
       className={'modal-connect-wallet'} 
       isOpen={isShowModalWallet} 
       
      >
       <div className='modal-header'>
          <h5 className='modal-title'>Choose Wallet</h5>
          <button
            type='button'
             onClick={toggleWalletModal}
            className='btn close'
            aria-label='Close'
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>  
     <ModalBody>
       <div className="wallet-option" >
           
          {getOptions()}

       </div>

     { isConnectError  ? 
      <div className="connect-wallet-error">
        <label>
          <pre>{  connectErrorMessage }</pre>
        </label>
 
      </div> 
      : null
       }
    

      </ModalBody>

    </Modal>
    </div>
  )
}
